import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card.tsx";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart.tsx";
import { PolarAngleAxis, PolarGrid, Radar, RadarChart } from "recharts";
import { TrendingUp } from "lucide-react";

export const RadarChart2 = ({chartData}) => {
   
    const chartConfig = {
        score: {
            label: "Score",
            color: "var(--chart-1)",
        },
    } satisfies ChartConfig;

    return (
        <Card>
            <CardHeader className="items-center">
                <CardTitle>Customer Experience Assessment</CardTitle>
                <CardDescription>
                    Performance across key customer experience metrics
                </CardDescription>
            </CardHeader>
            <CardContent className="pb-0">
                <ChartContainer
                    config={chartConfig}
                    className="mx-auto aspect-square max-h-[400px]"
                >
                    <RadarChart data={chartData}>
                        <ChartTooltip cursor={false} content={<ChartTooltipContent/>}/>
                        <PolarAngleAxis dataKey="metric"/>
                        <PolarGrid/>
                        <Radar
                            dataKey="score"
                            fill="var(--color-score)"
                            fillOpacity={0.6}
                            dot={{
                                r: 4,
                                fillOpacity: 1,
                            }}
                        />
                    </RadarChart>
                </ChartContainer>
            </CardContent>
            <CardFooter className="flex-col gap-2 text-sm">
                <div className="flex items-center gap-2 leading-none font-medium">
                    Trending up by 5.2% this month <TrendingUp className="h-4 w-4"/>
                </div>
                <div className="text-muted-foreground flex items-center gap-2 leading-none">
                    Q2 2025 Assessment
                </div>
            </CardFooter>
        </Card>
    );
};
